<script setup lang="ts">
const isFeatureEnabled = useFeatureFlag()
</script>

<template>
  <div v-if="isFeatureEnabled" class="flex gap-2 z-40">
    <slot />
    <span class="h-2 w-2 mt-1 rounded-full bg-yellow-500"></span>
  </div>
</template>
